document.addEventListener('DOMContentLoaded', function() {
  const targets = [
    document.querySelector('.mobile-facets__disclosure'),
    document.querySelector('.menu-drawer-container')
  ].filter(Boolean);

  if (!targets.length) return;

  const toggle = () => {
    const anyOpen = targets.some(el => el.classList.contains('menu-opening'));
    const cornerBtn = document.querySelector('.coca-cowi-corner-button-item');

    if (anyOpen) {
      if (cornerBtn) cornerBtn.style.setProperty('display', 'none', 'important');
      try { if (window.tidioChatApi) window.tidioChatApi.hide(); } catch(e) {}
    } else {
      if (cornerBtn) cornerBtn.style.removeProperty('display');
      try { if (window.tidioChatApi) window.tidioChatApi.show(); } catch(e) {}
    }
  };

  targets.forEach(el => {
    const observer = new MutationObserver(toggle);
    observer.observe(el, { attributes: true, attributeFilter: ['class'] });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a[href^="mailto:"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      var email = this.href.replace('mailto:', '');
      window.open('https://mail.google.com/mail/u/0/?view=cm&fs=1&to=' + email, '_blank');
      });
  });
});


if (window.innerWidth <= 768) {
  setTimeout(() => {
    let tab = document.getElementById('vstar-tab');
    if (tab) tab.textContent = '★';
  }, 2000);
}